import { AM_TYPES } from 'enums/ENUMS'

// TODO: add more to AM enums
export default (type: string): string => {
	switch (type) {
		case AM_TYPES.HAZARD_RATIO:
			return 'HR'
		case AM_TYPES.ODDS_RATIO:
			return 'OR'
		case AM_TYPES.MEAN_DIFFERENCE:
			return 'MD'
		case 'Rate Ratio':
			return 'IRR'
		case AM_TYPES.RAW_DIFFERENCE:
			return 'Raw D.'
		case AM_TYPES.RISK_RATIO:
			return 'RR'
		case AM_TYPES.RISK_RATIO_RELATIVE_RISK:
			return 'RR'
		case AM_TYPES.RELATIVE_RISK_INCREASE:
			return 'RRI'
		case AM_TYPES.RELATIVE_RISK_REDUCTION:
			return 'RRR'
		case AM_TYPES.RISK_DIFFERENCE:
			return 'RD'
		case 'Cohen\'s D':
			return 'CD'
		case 'Hedges G':
			return 'HG'
		default:
			return type
	}
}
